import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

export default function RentalHeroImage() {
  return (
    <motion.img
      src={IMAGES.rental.hero}
      alt="Benny's Pølsevogn på hjul"
      className="w-full h-full object-cover"
      initial={{ scale: 1.1, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 1 }}
    />
  );
}